import { isNumber } from 'lodash';

import { useApi } from 'hb-builder/api';
import type { UserBannerDataResponse } from 'hb-builder/api/userBanner/types';
import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance } from 'hb-react/shared/utils/axios';

const QUERY_KEY = 'dynamic_search_user_banner';

export const useGetUserInUserBanner = ({
  enabled = true,
}: {
  enabled?: boolean;
}) => {
  const { authenticationIds } = useApi();
  const { network: networkId, user: userId } = authenticationIds;

  const url = userId && Routes.preview_user_user_path(networkId, userId);

  const queryFn = async (): Promise<UserBannerDataResponse | undefined> => {
    if (url) {
      const { data } = await axiosInstance.get(url, {
        params: authenticationIds,
      });

      return data?.user;
    }

    return Promise.resolve(undefined);
  };

  return useQueryOnce([QUERY_KEY, networkId, userId], queryFn, {
    enabled: isNumber(networkId) && isNumber(userId) && enabled,
  });
};
